import React from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
import { LineChart, Tooltip, Text } from "components/commons";
import { formatNumberWithComma } from "services";
import {
  formatNumberToMoneyWithCurrencySymbol,
  formatNumberToMoneyCurrency,
  getCurrencySymbol,
} from "services/money.service";
import classnames from "classnames";
import styles from "../dashboard-charts.module.scss";

const MIN_VISIBLE_PERCENTAGE = 2;

const getPercentages = (data) => {
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);
  if (!total) {
    return [];
  }

  const percentages = data.map((item) => Math.round((Number(item.value || 0) / total) * 100));
  const roundedTotal = percentages.reduce((sum, value) => sum + value, 0);
  if (roundedTotal !== 100) {
    const largestIndex = percentages.indexOf(Math.max.apply(Math, percentages));
    percentages[largestIndex] = percentages[largestIndex] - (roundedTotal - 100);
  }

  const visiblePercentages = percentages.map((value, index) => {
    if (!data[index]?.value) {
      return 0;
    }
    return Math.max(value, MIN_VISIBLE_PERCENTAGE);
  });
  const visibleTotal = visiblePercentages.reduce((sum, value) => sum + value, 0);
  const excess = visibleTotal - 100;
  if (excess > 0) {
    const largestIndex = visiblePercentages.indexOf(Math.max.apply(Math, visiblePercentages));
    visiblePercentages[largestIndex] = Math.max(
      visiblePercentages[largestIndex] - excess,
      MIN_VISIBLE_PERCENTAGE,
    );
  }

  return visiblePercentages;
};

const TopUpsStackChart = ({ data = [] }) => {
  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);
  const percentages = getPercentages(data);

  return (
    <div>
      <div className={classnames("my-sm", styles.kpiAmount)}>
        <span className={styles.kpiCurrency}>{getCurrencySymbol()}</span>
        <span className={styles.kpiNumber}>{formatNumberToMoneyCurrency(total || 0)}</span>
      </div>
      <div className="flex mt-md">
        {data.map((item, index) => (
          <Tooltip
            key={`${item.label}-${index}`}
            title={
              <div className="text-center">
                <Text color="text-white" size="text-xs">
                  {item.label} - {`${formatNumberWithComma(percentages[index])}%`}
                </Text>
                <Text color="text-white">{formatNumberToMoneyWithCurrencySymbol(item.value)}</Text>
              </div>
            }
          >
            <div
              className="text-gray hover:text-black"
              style={{ width: `${percentages[index]}%` }}
            >
              <div className="w-full h-4" style={{ backgroundColor: item.color }} />
            </div>
          </Tooltip>
        ))}
      </div>
      <div className={styles.topUpsLegend}>
        {data.map((item, index) => (
          <Tooltip
            key={`${item.label}-legend-${index}`}
            title={
              <div className="text-center">
                <Text color="text-white" size="text-xs">
                  {item.label} - {`${formatNumberWithComma(percentages[index])}%`}
                </Text>
                <Text color="text-white">{formatNumberToMoneyWithCurrencySymbol(item.value)}</Text>
              </div>
            }
          >
            <div className={styles.topUpsLegendItem}>
              <span className={styles.topUpsLegendSwatch} style={{ backgroundColor: item.color }} />
              <span>{item.label}</span>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

const TotalTopUpsChart = ({ ...props }) => {
  const barStackChart = props.mappedData.barChartData;
  const lineChart = props.mappedData.lineChartData;
  return (
    <ChartContainer
      title={lang.totalTopUps}
      {...props}
      empty={!props.mappedData.total}
      emptyText={lang.noSalesInDateRange}
      className={styles.roundedChartCard}
    >
      <TopUpsStackChart data={barStackChart} />
      {/* <LineChart
        {...lineChart}
        formatToolTipValue={(v) => {
          return formatNumberToMoneyWithCurrencySymbol(v.value);
        }}
        // formatYAxis={(label) => {
        //   return formatNumberToMoneyWithCurrencySymbol(label);
        // }}
      /> */}
    </ChartContainer>
  );
};

export default TotalTopUpsChart;
